import type { MonospaceCollectionMeta, MonospaceSerializedCollection } from '#layers/data-model';
import { RStoreSchema } from '#imports';

export const Collection = RStoreSchema.withItemType<MonospaceSerializedCollection>().defineCollection({
	name: 'MonospaceCollection',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'dbName', 'apiName', 'isReadOnly', 'isSystem', 'sourceId', 'namespaceId'],
		useProjectSlug: true,
	},
});

export const CollectionMeta = RStoreSchema.withItemType<MonospaceCollectionMeta>().defineCollection({
	name: 'MonospaceCollectionMeta',
	scopeId: 'monospace-default',
	getKey: (item) => item.collectionId,
	meta: {
		defaultFields: ['collectionId', 'displayTemplate', 'displayName', 'description', 'icon', 'isHidden', 'color'],
		connect: {
			collectionId: ['collection', 'id'],
		},
		useProjectSlug: true,
	},
});
